import CTLUnReadCell from "application/components/CTLUnReadCell";
import { BillingReportMenu } from "globals/configuration/BillingReportMenu";

const Attributes = {
  enableAddButton: false,
  enableUpdateTableRecords: true,
  enableRefresh: true,
  enableAdvanceSearch: false,
  // Resend email toolbar button (task #9879) — reuses the existing generic Email
  // toolbar slot (CTLNavBar enableEmailButton -> onSendEmail) rather than the
  // Broadcast-Message Send button, so the tooltip/icon read correctly here.
  enableEmailButton: true,
  modes: BillingReportMenu.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
};

const operationURLS = {
  // Pooled/scheduled report list (task #9574) — report_type-scoped, distinct from the
  // Voice Logger /pdfReport/list.
  list: "/pdfReport/scheduled/list",
  reportDownload: "pdfReport/download",
  // Re-queue delivery email for an already-generated report (task #9879).
  resendEmail: "/pdfReport/resendEmail",
};

const getColumns = (onDownload) => {
  return [
    {
      Header: "Report ID",
      accessor: "id",
      displayInList: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Report Name",
      accessor: "reportName",
      displayInList: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Status",
      accessor: "status",
      displayInList: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Created",
      accessor: "createdOnDate",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Started",
      accessor: "startedOn",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Completed",
      accessor: "completedOn",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Failure Reason",
      accessor: "failureReason",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    // Email delivery fields (task #9594) — surfaced from /pdfReport/scheduled/list. Booleans are
    // rendered Yes/No and timestamps are rendered as-is, matching the existing date columns.
    {
      Header: "Email ID",
      accessor: "emailId",
      displayInList: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Email Name",
      accessor: "emailName",
      displayInList: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Send Email",
      accessor: "sendEmail",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => (
        <CTLUnReadCell value={value === true ? "Yes" : value === false ? "No" : value} />
      ),
    },
    {
      Header: "Email Sent",
      accessor: "emailSent",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => (
        <CTLUnReadCell value={value === true ? "Yes" : value === false ? "No" : value} />
      ),
    },
    {
      Header: "Email Sent On",
      accessor: "emailSentOn",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Email Status",
      accessor: "emailStatus",
      displayInList: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Email Failure Reason",
      accessor: "emailFailureReason",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Template ID",
      accessor: "emailTemplateId",
      displayInList: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Download",
      accessor: "download",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ row }) => {
        const report = row.original;
        const ready = report.status === "success";
        return (
          <span
            onClick={() => ready && onDownload(report.id)}
            style={{
              cursor: ready ? "pointer" : "not-allowed",
              color: ready ? "#1A73E8" : "#9e9e9e",
              fontWeight: 600,
            }}
            title={ready ? "Download report" : "Available once completed"}
          >
            Download
          </span>
        );
      },
    },
  ];
};

export { getColumns, Attributes, operationURLS };
